import { createSlice } from "@reduxjs/toolkit";
import { RefundOrder } from "../views/Payment/OrderRefund";

interface RefundOrderState {
    refundOrders: RefundOrder[];
    loading: boolean;
    error: any;
    rowsPerPage: number;
    status: { value: string, label: string },
}

const initialState: RefundOrderState = {
    refundOrders: [],
    loading: false,
    error: null,
    rowsPerPage: 10,
    status: { value: "All", label: "ALL" },
};

export const dashBoardSlice = createSlice({
    name: "refundOrders",
    initialState,
    reducers: {
        setRefundOrderStatus: (state, action) => {
            state.status = action.payload;
        },
        setRowsPerPage(state, action) {
            state.rowsPerPage = action.payload;
        },
        clearRowsPerPage(state) {
            state.rowsPerPage = 10;
        }
    },
});

export const { setRowsPerPage, clearRowsPerPage, setRefundOrderStatus } = dashBoardSlice.actions;

export default dashBoardSlice.reducer;
